import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ControlBar } from '../chrome/ControlBar';
import { TitleBar } from '../chrome/TitleBar';
import { About } from './About';
import { AppProviders } from '../providers/AppProviders';
import { AuthGate } from '../auth/AuthGate';

export const AboutPage: React.FC = () => {
  const navigate = useNavigate();
  
  const handleTekkenTreeClick = () => {
    navigate('/tree/tekken-8');
  };
  
  return (
    <AppProviders treeId="about">
        <AuthGate isDevelopment={false}>
            <div className="about-page-container">
                <ControlBar 
                isDraft={false}
                showSaveButton={false}
                isEditMode={false}
                />
                <TitleBar title="About Skill Trees" />
                <div className="about-scrollable-content">
                    <About />
                </div>
                
                {/* Floating "Tekken 8 Skill Tree" button */}
                <div 
                  className="tekken-tree-button"
                  onClick={handleTekkenTreeClick}
                >
                  <h3>Tekken 8 Skill Tree</h3>
                </div>
                
                {/* Floating Patreon support button */}
                <div className="patreon-support-button">
                  <a 
                    href="https://patreon.com/SkillTreesGG" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <div className="patreon-content">
                      <span className="patreon-text">Support On Patreon</span>
                      <img 
                        src="/images/about/patreon-symbol.png" 
                        alt="Patreon" 
                        className="patreon-logo"
                      />
                    </div>
                  </a>
                </div>
            </div>
        </AuthGate>
    </AppProviders>
  );
};
